import { z } from 'zod';
import { privateCidrRequiredSchema } from '#schemas/general/cidr.ts';
import { configOverridesFieldSchema } from '#screens/tags/form/config-overrides/config-overrides-field-schema.ts';

export const networkFormSchema = z.object({
  networkName: z
    .string()
    .min(1, 'Please choose a name for this network')
    .max(50, 'Name cannot be longer than 50 characters'),
  description: z.string(),
  cidrV4: privateCidrRequiredSchema.or(z.literal('')).optional(),
  cidrV6: z.string().optional(),
  lighthousesAsRelays: z.boolean(),
  curveP256: z.boolean().optional(),
  // Positive form field; inverts to the API's `disableManagedLighthouses` at the boundary.
  useManagedLighthouses: z.boolean(),
  // Network-wide config overrides. Saved through the
  // dedicated PUT /v1/networks/:id/config-overrides endpoint, not the network PUT.
  configOverrides: configOverridesFieldSchema,
});

export type NetworkFormData = z.infer<typeof networkFormSchema>;
